import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { comentariosOportunidad } from "src/app/proceso-operativo/modelos/comentariosOportunidad.model";
import { OperativoService } from "src/app/proceso-operativo/opeartivo.service";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { ArchivosUtileriasService } from "src/app/utilerias/service/archivo-utilerias.service";

import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatListModule } from "@angular/material/list"; // FIX: para mat-selection-list / mat-list-option
import { MatRadioModule } from "@angular/material/radio";

import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

@Component({
  selector: "app-vobo-oportunidad",
  standalone: true,
  templateUrl: "./vobo-oportunidad.component.html",
  styleUrls: ["./vobo-oportunidad.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    NgxMatSelectSearchModule,
    MatListModule, // FIX
    ],
})
export class VoboOportunidadComponent implements OnInit {
  formVobo: FormGroup;
  listaArchivos: File[] = [];
  listaArchivosSelect: File[] = [];
  PREFIJO_VOBO = "VOBO-";

  permitirCargaArchivo: boolean = false;

  comentarioOportunidad: comentariosOportunidad = new comentariosOportunidad();

  constructor(
    readonly formBuilder: FormBuilder,
    readonly dialogRef: MatDialogRef<VoboOportunidadComponent>,
    readonly service: OperativoService,
    readonly archivoUtils: ArchivosUtileriasService,
    readonly msg: Msg,
    @Inject(MAT_DIALOG_DATA) public datoEntrada: any
  ) {}

  validarMedioVobo(control: AbstractControl) {
    const value = control.value;
    if (value === null || value === undefined || value === "") {
      return { required: true };
    }
    return null;
  }

  ngOnInit() {
    this.formVobo = this.formBuilder.group({
      comentarioCtrl: ["", [Validators.required]],
      medioRecepcionCtrl: [null, [this.validarMedioVobo.bind(this)]],
    });

    this.permitirCargaArchivo = false;

    this.formVobo
      .get("medioRecepcionCtrl")
      ?.valueChanges.subscribe((val: number | null) => {
        console.log("Cambio medioRecepcionCtrl:", val);

        if (val === 0) {
          this.permitirCargaArchivo = false;
          this.listaArchivos = [];
          this.listaArchivosSelect = [];
          return;
        }

        this.permitirCargaArchivo = val !== null;

        if (!this.permitirCargaArchivo) {
          this.listaArchivos = [];
          this.listaArchivosSelect = [];
        }
      });

    if (this.datoEntrada) {
      this.comentarioOportunidad.idGit = this.datoEntrada.idGit;
      this.comentarioOportunidad.estado = this.datoEntrada.estado;
    }
  }

  public onChangeMedioRecepcion() {
    const valor = this.formVobo.get("medioRecepcionCtrl")?.value;

    if (valor === 0) {
      this.permitirCargaArchivo = false;
      this.listaArchivos = [];
      this.listaArchivosSelect = [];
      return;
    }

    this.permitirCargaArchivo = valor !== null;
  }

  onCargarVobo(event: Event) {
    if (!this.permitirCargaArchivo) return;

    this.listaArchivos = this.archivoUtils.agregarCargaArchivo(
      "inputFileVobo",
      this.listaArchivos,
      /.*/
    );
  }

  onChangeFileSelect($event: any) {
    this.listaArchivosSelect = $event;
  }

  onEliminarVobo() {
    this.listaArchivos = this.archivoUtils.removerCargaArchivo(
      "inputFileVobo",
      this.listaArchivos,
      this.listaArchivosSelect
    );
    this.listaArchivosSelect = [];
  }

  public onCloseClick(): void {
    this.dialogRef.close();
  }

  public guardarVoboClick() {
    if (this.formVobo.valid && this.validarTipoVobo()) {
      this.comentarioOportunidad.contenido = this.formVobo.value.comentarioCtrl;
      this.comentarioOportunidad.archivosComentarios = this.getListaEvidencia();

      if (this.listaArchivos.length > 0) {
        this.service
          .guardarArchivoGit(this.getFormEvidencia())
          .subscribe((response: any) => {
            if (response?.status === "ok") {
              this.enviarComentario();
            }
          });
      } else {
        this.enviarComentario();
      }
    }
  }

  public validarTipoVobo(): boolean {
    const tipoVobo = this.formVobo.get("medioRecepcionCtrl")?.value;

    if (tipoVobo === null || tipoVobo === undefined) return false;

    if (tipoVobo === 0) return true;

    if (this.listaArchivos.length === 0) return false;

    return true;
  }

  private enviarComentario() {
    const tipoVobo = this.formVobo.get("medioRecepcionCtrl")?.value;
    this.dialogRef.close({
      codError: "00000",
      tipoVobo: tipoVobo === 0 ? "" : tipoVobo,
      comentario: this.formVobo.value.comentarioCtrl,
      listaArchivos: this.comentarioOportunidad.archivosComentarios,
    });
  }

  private getListaEvidencia(): any[] {
    return this.listaArchivos.map((element) => ({
      name: this.PREFIJO_VOBO + element.name,
      type: element.type,
    }));
  }

  private getFormEvidencia(): FormData {
    const reqForm = new FormData();
    reqForm.append("idProyecto", this.datoEntrada.idGit.toString());
    this.listaArchivos.forEach((archivo) => {
      reqForm.append("file", archivo, this.PREFIJO_VOBO + archivo.name);
    });
    return reqForm;
  }
}
